/*eslint-disable*/
import React from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";

const clients = [
  { img: require("assets/img/edge/harness-gym.png"),     alt: "Harness Gym",     label: "Harness Gym — AI Agent Auth Testbed",         vertical: "AI INFRASTRUCTURE", href: "https://oauth-test.edgeventures.com" },
  { img: require("assets/img/edge/generals-ai.png"),     alt: "Maven",           label: "Maven — Voice AI iOS & Android App",          vertical: "VOICE AI", to: "/products/maven", internal: true },
  { img: require("assets/img/edge/last-episode-appstore.png"), alt: "Last Episode", label: "Last Episode — iOS & Android App",         vertical: "ENTERTAINMENT", href: "https://apps.apple.com/us/app/last-episode/id6768906712" },
  { img: require("assets/img/edge/doodletoon-site.png"), alt: "DoodleToon",     label: "DoodleToon — AI Animated App",                vertical: "CREATIVE TOOLS", href: "https://doodletoon.ai" },
  { img: require("assets/img/edge/talent-systems.png"),  alt: "Talent Systems",  label: "Talent Systems — ETL Architecture Redesign", vertical: "ENTERTAINMENT", href: "https://www.talentsystems.com/", objPos: "center" },
  { img: require("assets/img/edge/sabio.png"),           alt: "Sabio",           label: "Sabio — Ad Tech Data Architecture Assessment", vertical: "ENTERTAINMENT", href: "https://sabio.inc/", objPos: "top left" },
  { img: require("assets/img/edge/squabble.png"),        alt: "Squabble.io",     label: "Squabble.io — AI Agent Debates",             vertical: "AI AGENTS", href: "https://squabble.io/" },
  { img: require("assets/img/edge/temperature-pro.png"), alt: "Temperature Pro", label: "Temperature Pro — Data Warehouse",            vertical: "HOME SERVICES", href: "https://temperaturepro.com/" },
  { img: require("assets/img/edge/allvoices.png"),       alt: "All Voices",      label: "All Voices — ETL & NLP Integration",          vertical: "WORKPLACE", href: "https://www.allvoices.co/" },
  { img: require("assets/img/edge/stylette.png"),        alt: "Stylette",        label: "Stylette — Technical Consulting",             vertical: "E-COMMERCE", href: "https://www.stylette.com/" },
  { img: require("assets/img/edge/lennar.png"),          alt: "Lennar",          label: "Lennar — ETL & Transformation",               vertical: "REAL ESTATE", href: "https://www.lennar.com/" },
  { img: require("assets/img/edge/goop.png"),            alt: "Goop",            label: "Goop — Redshift Transformations",             vertical: "E-COMMERCE", href: "https://goop.com/" },
  { img: require("assets/img/edge/avantax.png"),         alt: "Avantax",         label: "Avantax — Delivery Experience",               vertical: "FINANCE", href: "https://avantax.com/" },
  { img: require("assets/img/edge/cetera.png"),          alt: "Cetera",          label: "Cetera — Delivery Experience",                vertical: "FINANCE", href: "https://cetera.com/" },
  { img: require("assets/img/edge/little-bee.png"),      alt: "Little Bee",      label: "Little Bee — Real Estate Investments",         vertical: "REAL ESTATE", href: "https://littlebee.us/" },
];

function PastProjects() {
  return (
    <section className="edge-clients-section" id="past-work">
      <Container>
        <span className="edge-section-eyebrow">{"// PAST WORK"}</span>
        <h2 className="edge-section-heading">
          Where we've<br />
          <span className="muted">delivered</span>
        </h2>
        <p className="edge-section-sub">
          Our primary verticals are real estate, e-commerce, finance, and entertainment.
        </p>

        <div className="edge-clients-grid">
          {clients.map(c => {
            const inner = (
              <>
                <img
                  src={c.img}
                  alt={c.alt}
                  className="edge-client-img"
                  style={c.objPos ? { objectPosition: c.objPos } : undefined}
                />
                <div className="edge-client-label">
                  {c.label}
                  {c.vertical && (
                    <span className="edge-client-vertical"> · {c.vertical}</span>
                  )}
                </div>
              </>
            );
            return c.internal ? (
              <Link key={c.alt} to={c.to} className="edge-client-card">
                {inner}
              </Link>
            ) : (
              <a
                key={c.alt}
                href={c.href}
                target="_blank"
                rel="noreferrer"
                className="edge-client-card"
              >
                {inner}
              </a>
            );
          })}
        </div>
      </Container>
    </section>
  );
}

export default PastProjects;
